export const GET_NOTIFICATIONS_SUCCEEDED = 'Notifications/GET_SUCCEEDED';
export const GET_NOTIFICATIONS_ERROR = 'Notifications/GET_ERROR';

export const GET_MORE_NOTIFICATIONS_SUCCEEDED =
  'Notifications/GET_MORE_SUCCEEDED';
export const GET_MORE_NOTIFICATIONS_ERROR = 'Notifications/GET_MORE_ERROR';

export const GET_UNREAD_NOTIFICATIONS_COUNT_SUCCEEDED =
  'Notifications/GET_UNREAD_COUNT_SUCCEEDED';
export const GET_UNREAD_NOTIFICATIONS_COUNT_ERROR =
  'Notifications/GET_UNREAD_COUNT_ERROR';

export const LOADING_STATE = 'Notifications/LOADING_STATE';
